import { getStoykaName } from "../../helpers/getStoykaName";
import { toggleChildByName } from "../../togglers/toggleChildByName";

export const changePokritiePolokSP = (checked, type) => {
    const namesMap = {
        zink: "otsinkovka",
    };

    const stoykaName = getStoykaName();
    const name = `dopolnitelnoe_pokritie_polok__${namesMap[type]}__stol__${stoykaName}`;

    toggleChildByName(name, checked);
};
